import { SvgIconPropsColorOverrides, useTheme } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import { IgCustomTheme } from "../theme";

export type ColorType =
  | OverridableStringUnion<
      | "success"
      | "warning"
      | "error"
      | "info"
      | "inherit"
      | "action"
      | "disabled"
      | "primary"
      | "secondary"
      | "accent"
      | "light"
      | "dark"
      | "lightHover"
      | "darkHover"
      | "accentHover",
      SvgIconPropsColorOverrides
    >
  | undefined;
export const useGetSvgIconFill = (
  color: ColorType | undefined,
  defaultColor?: ColorType
): string => {
  const theme = useTheme();

  switch (color) {
    case "dark":
      return (theme as IgCustomTheme).igIconColors.dark;
    case "success":
      return (theme as IgCustomTheme).igIconColors.success;
    case "warning":
      return (theme as IgCustomTheme).igIconColors.warning;
    case "error":
      return (theme as IgCustomTheme).igIconColors.error;
    case "accent":
      return (theme as IgCustomTheme).igIconColors.accent;
    case "info":
      return (theme as IgCustomTheme).igIconColors.info;
    case "accentHover":
      return (theme as IgCustomTheme).igIconColors.accentHover;
    case "darkHover":
      return (theme as IgCustomTheme).igIconColors.darkHover;
    case "lightHover":
      return (theme as IgCustomTheme).igIconColors.lightHover;

    default:
      return (theme as IgCustomTheme).igIconColors[defaultColor || "light"];
  }
};
